import {ApiVisa, BaseApiTemplateService, Core2Config} from "../../../shared";

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { VoiceCallContainer } from "../../../../../../../models/mongodbSchema/aggregates";


@Injectable({ providedIn: 'root' })
export class VoiceCallService extends BaseApiTemplateService<VoiceCallContainer> {

  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
  }

}